import setting from '@/api/setting/sys-setting'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context) {
    return setting.get()
  },
  store(context, data) {
    return setting.store(data)
  },
  getCogs(context){
    return setting.getCogs()
  }
}
